import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal, EmailModal, UploadDocumentModal } from 'src/modules/shared';
import { SelectDocumentModal } from 'src/modules/features/admin/modals';
@Component({
	selector: 'app-award-agent-contact',
	templateUrl: './award-contact.component.html',
	styleUrls: [ './award-contact.component.scss' ]
})
export class AwardAgentContactComponent implements OnInit {
	documents;
	constructor(private modalService: SuiModalService) {}
	deleteDoc() {
		this.modalService
			.open(new ConfirmModal('Delete Document', 'Are you sure you want to delete this document?', ModalSize.Tiny))
			.onApprove(() => {})
			.onDeny(() => {});
	}
	sendEmail() {
		this.modalService
			.open(
				new EmailModal('Send Email', 'Are you sure you want to delete this Advertisement plan?', ModalSize.Tiny)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	addDocument() {
		this.modalService
			.open(
				new SelectDocumentModal(
					'Select Document Template',
					'Are you sure you want to delete this Advertisement plan?',
					ModalSize.Tiny
				)
			)
			.onApprove(() => {})
			.onDeny(() => {});
	}
	ngOnInit(): void {}
}
